module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'withinFormTable'
	],

	config: {
		buttonContext: 'tripDriverVessels',
		showHead: true,
		// showIDs: true,
		showTDVerticalTop: true,
		isSortable: true,
		inline: false,
		// lazyloadStepSize: 10,
		preventSortOfField: {
			status: true,
		},
		// sortByDragging: true,
		headRowActions: {
			// toggleSortByDragging: {
			// 	show: true,
			// 	turnedOn: false,
			// },
		},
		rowActionsInline: true,
		rowActionsProperties: {
			colWidth: '65px',
		},
		rowActions: {
			edit: true,
			customs: [
				{
					buttonType: 'delete',
					neutral: true,
				}
			]
		},
		addRowClassViaAttribute: [
			{
				fieldCode:  'driverActive',
				value:      false,
				class:      'isInactive',
			},
		],
		heartbeatRefreshOn: {
			'reconnect': true,
			'resourceChanged.bosch_drivers': true,
			'resourceChanged.bosch_trips': true,
			'resourceChanged.bosch_tripDriverVessels': true,
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'position',
				direction: 'asc'
			}]
		}
	},

	methods: {

		onBuild(){
			this.config.customHeadActionsFormMapping = {
				buttons: [
					{ buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
				]
			}
		},

		/**
		 * can this driverID be found within the actual loaded resources
		 * @param wantedDriverID     int
		 * @returns {boolean}
		 */
		isDriverIDInUse(wantedDriverID){
			if(!wantedDriverID){
				return false
			}

			for(const {attributes: {driverID}} of this.resourceData.data || []){
				if(driverID == wantedDriverID){
					return true
				}
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers 	= this.config.heartbeatRefreshOn || {}
			const key 			= message.heartbeatKey
			const baseFilters 	= (this.model.parentEntityForTable || {}).baseFilters || {}
			const myTripID 		= baseFilters.tripID

			if(refreshers[key] && (
				(key === 'reconnect') ||
				(key === 'resourceChanged.bosch_trips') || // conflicts with other trip's tripDriverVessels are unpredictable.
				(key === 'resourceChanged.bosch_drivers' && this.isDriverIDInUse(message.data.driverID)) ||
				(key === 'resourceChanged.bosch_tripDriverVessels' && myTripID && myTripID == message.data.tripID)
			)){
				this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
			}
		},
	},
}